module.exports = __webpack_public_path__ + "static/media/headbang.dc53d979.gif";